var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('mega-table',{attrs:{"title":"Invoice Details","items":_vm.items,"fields":_vm.fields,"showDetails":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }